export default "__VITE_ASSET__C42vmc6G__"